class PushCartFooter extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (window.theme.cartLimit) {
      this.initialise()
    }
  }

  initialise () {
    this.toggleOrderLimitUI()
  }

  toggleOrderLimitUI () {
    const cartTotal = Number(this.dataset.cartTotal)

    if (cartTotal === 0) return

    const isCartTotalExceededLimit = cartTotal > this.orderLimit

    this.els.orderLimit?.element?.setAttribute(
      'aria-hidden',
      !isCartTotalExceededLimit,
    )

    this.els.form?.element?.setAttribute(
      'aria-hidden',
      isCartTotalExceededLimit,
    )

    if (this.els.promo) {
      this.els.promo?.element?.setAttribute(
        'aria-hidden',
        isCartTotalExceededLimit,
      )
    }
  }

  get orderLimit () {
    const convertedLimit =
      (window.theme.cartLimit / 100) * Number(window.Shopify.currency.rate)
    const convertedLimitInPence = Math.round(convertedLimit * 100)

    return convertedLimitInPence
  }
}

if (!customElements.get('push-cart-footer')) {
  customElements.define('push-cart-footer', PushCartFooter)
}
